export default __webpack_public_path__ + "static/media/doc-word.70339ae2.svg";